<template>
    <div class="notice-list">
        <div class="global" >
            <ul class="items" v-if="pagelist.length != 0">
                <router-link :to="{ name:'NoticeDetail', params:{ id: item.noticeId, receiverId: item.noticReceiverId,userId:userId} }" tag="li" v-for="item in pagelist" :key="item.noticeId" @click.native="hasRead(item.noticeId)"  >
                    <h3><i class="iconfont icon-lingdang"></i><em class="dot" v-if="item.readFlag != 1" ></em>{{ item.title }}</h3>
                    <time class="time" >{{item.makeTime}}</time>
                </router-link>
            </ul>
            <div class="no-leave" v-else >暂无公告通知</div>
            <!-- 底部返回上一页 返回首页信息放这里 -->
            <bottom></bottom>
        </div>
    </div>
</template>

<script>
import Bottom from '../bottom.vue'
import _ from 'lodash';
export default {
    data() {
        return {
            pagelist: [],   //公告通知列表
            userId: this.$route.query.userId   //用户id   
        }
    },
    components: { Bottom },
    mounted () {
        this.$http.get( '/api/mobile/notice/queryNoticeByPage',
            {params: 
                {
                    page: 1,
                    rows: 10,
                    userId: this.userId
                }
            }
            ).then( res => {
                if(res.data.code == 0) {
                    this.pagelist = res.data.pagelist;
                } else if(res.data.code == 1) {
                    alert('登录超时,请重新登录!');
                    this.$router.replace({ name: 'Login' });
                } else {
                    alert(res.data.message);
                }
            })
    },
    methods: {
        hasRead (id) {
            // 点击后则标记为已读,红点标记去除
            this.pagelist = _.map(this.pagelist, item => {
                if(item.readFlag == 0) {
                    this.$http.get('/api/mobile/notice/signRead',
                        {params:
                            {
                                noticeId: this.$route.params.id,  //公告id
                                noticeReceiverId: this.$route.params.receiverId,  //公告接收表id
                                userId: this.userId
                            }
                        }
                        ).then( res => {
                                console.log(res.data.message);
                        }) 
                }
                return item;
            })
            
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/notice/notice.vue